import styled, {css} from 'styled-components'

export const StyledHeaderContainer = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
        padding: ${spacing * 3}px;
        height: 56px;
        align-items: center;
        justify-items: center;
        gap: ${spacing * 3}px;

        & > :last-child {
            justify-self: right;
        }

        & > :first-child {
            justify-self: left;
        }
    `
)
